import logger from './logger';
import { CMS_GIT_URL } from '../config/default';

const fetchValue = async () => {
    try {
        const response = await fetch(CMS_GIT_URL);
        return response.json();
    } catch (error) {
        logger.handleError(error);
        throw error;
    }
}

export default fetchValue;
